module.exports = __webpack_public_path__ + "img/h-1.1c92a3f8.png";